import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Terms from '@/components/Terms'
import Contact from '@/components/Contact'
import Privacy from '@/components/Privacy'
import Gallery from '@/components/Gallery'
import FourOhFour from '@/components/FourOhFour'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
	linkActiveClass: 'active',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/about',
			name: 'about',
			component: About
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact
		},
		{
			path: '/gallery',
			name: 'gallery',
			component: Gallery
		},
		// {
		// 	path: "/terms-and-conditions",
		// 	name: "terms",
		// 	component: Terms
		// },
		// {
		// 	path: '/privacy-policy',
		// 	name: 'privacy',
		// 	component: Privacy
		// },
		{ path: '*', component: FourOhFour }
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js